import classes from './Tab.module.css.mjs';

const tabTypeClasses = {
  horizontal: classes.tabHorizontal,
  vertical: classes.tabVertical
};

export { tabTypeClasses };
